import { Empty, Popover } from 'antd';
import React from 'react';
import {
  compareDietaryIngredients,
  compareOriginNutrients,
  getNutrientList,
} from '../utils';
import VerticalLabel from '../VerticalLabel';
import VerticalLabelWithMicronutrient from '../VerticalLabelWithMicronutrient';
import LinearLabel from '../LinearLabel';
import SupplementStandardLabel from '../../../supplement-label';
import { PanelContextContainer } from 'pages/product-full-view/components/product-media-area/multiple-panel/components';
import { useCheckIsProductOverlay } from 'hooks/product';

export const WrapperPopover = ({ content, children, ...restProps }) => {
  if (!content) return <div>{children}</div>;

  return (
    <Popover content={content} {...restProps}>
      <div>{children}</div>
    </Popover>
  );
};

const WrapperFactsPanelItem = ({ property, children, ...restProps }) => {
  const { originData } = property ?? {};

  const isOverlay = useCheckIsProductOverlay();

  if (!isOverlay) return <div>{children}</div>;

  const panelFactsType = originData?.factsPanelType;

  const FactsPanel = {
    SupplementFactsPanel: RenderSupplement,
    NutritionFactsPanel: RenderNutritionPanel,
  };

  const FactPanelItem = FactsPanel?.[panelFactsType];
  const content = panelFactsType ? (
    <PanelContextContainer
      labelPreview={<FactPanelItem property={{ ...originData, originData }} />}
      downloadFileName={`${property?.factsPanelType}_${property?.id}`}
    >
      <FactPanelItem property={property} />
    </PanelContextContainer>
  ) : (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 245,
        height: 300,
      }}
    >
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    </div>
  );

  return (
    <WrapperPopover
      content={content}
      title={
        <span
          style={{
            fontSize: 18,
            backgroundColor: '#55acee',
            borderRadius: 4,
            padding: '0px 10px',
            color: 'white',
          }}
        >
          Original Value
        </span>
      }
      trigger='hover'
      placement='left'
      {...restProps}
    >
      {children}
    </WrapperPopover>
  );
};
export default WrapperFactsPanelItem;

const RenderNutritionPanel = ({ property }) => {
  const { nutritionFactProperties = [], originData, ...restLabel } = property;

  const labelType = {
    US_FDA_NFP_2020_STANDARD: VerticalLabel,
    US_FDA_NFP_2020_STANDARD_SIDE_BY_SIDE: VerticalLabelWithMicronutrient,
    US_FDA_NFP_2020_LINEAR_SMALL_PACKAGES: LinearLabel,
  };

  const nutrientFormatType = originData?.nutrientFormatType;
  const FactPanel = labelType?.[nutrientFormatType] || VerticalLabel;

  const overlayNutrients = compareOriginNutrients({
    originValue: originData?.nutritionFactProperties || [],
    overlayValue: nutritionFactProperties,
  });

  const nutrients = getNutrientList(overlayNutrients);

  return (
    <FactPanel
      label={originData}
      nutrients={nutrients}
      compareValue={restLabel}
    />
  );
};

const RenderSupplement = ({ property }) => {
  const { originData, nutrients, dietaryIngredients, ...restLabel } =
    property ?? {};

  const overlayNutrients = compareDietaryIngredients({
    originValue: originData?.nutrients || [],
    overlayValue: nutrients,
  });

  const overlayDietaryIngredients = compareDietaryIngredients({
    originValue: originData?.dietaryIngredients || [],
    overlayValue: dietaryIngredients,
  });

  return (
    <SupplementStandardLabel
      label={originData}
      compareValue={restLabel}
      nutrients={overlayNutrients}
      dietaryIngredients={overlayDietaryIngredients}
    />
  );
};
